import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import QRCode from 'qrcode.react';
import Barcode from 'react-barcode';
import { formatDate } from '../../../utils/'
import classNames from 'classnames';
import { API, CURRENCY } from '../../../constants';
import { formatMoney } from '../../../services';

export class ItemsVoucherOrder extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            barOrQrCode: {
                status: false,
                name: "",
                index: -1,
                voucherIndex: -1
            }
        }
    }
    
    toggleBarOrQrCode = (name, voucherIndex, index) => {
        const { barOrQrCode } = this.state;
        if (barOrQrCode.name === name && barOrQrCode.index == index && barOrQrCode.voucherIndex == voucherIndex) this.setState({ barOrQrCode: { ...barOrQrCode, status: false, name: "", index: -1, voucherIndex: -1 }});
        else this.setState({ barOrQrCode: { ...barOrQrCode, status: true, name, index, voucherIndex }});
    }
    
    createVoucher = (voucher, voucherIndex) => {
        const { barOrQrCode } = this.state;
        const { wording, currentLanguage } = this.props;

        return voucher.items?.map((item, index) => {
            return (
                <div
                    key={index}
                    className='content-warpper col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                    <div className="flex wrap-reverse vertical-center">
                        <div className='white'>
                            <div>
                                {`${wording.usermenu.voucher.name}: `}
                                {voucher.name}
                            </div>
                            <div>
                                {`${wording.usermenu.voucher.voucherNumber}: `}
                                {item}
                            </div>
                            <div>
                                {`${wording.usermenu.voucher.expireDate}: `}
                                <span  className={new Date(voucher.expiryDate) > Date.now() ? "color-green": "color-red"}>
                                    {formatDate(voucher.expiryDate)[currentLanguage]}
                                </span>
                            </div>
                        </div>
                        <div style={{ flex: "1 1 0%" }} className="flex horizontal-end m-10">
                            <button
                                className='btn btn-md btn-light mr-10'
                                onClick={() => this.toggleBarOrQrCode("barcode", voucherIndex, index)}>
                                {wording.usermenu.voucher.barcode}
                            </button>
                            <button
                                className='btn btn-md btn-light'
                                onClick={() => this.toggleBarOrQrCode("qrcode", voucherIndex, index)}>
                                {wording.usermenu.voucher.qrCode}
                            </button>
                        </div>
                    </div>
                    {
                        barOrQrCode.status && index == barOrQrCode.index && voucherIndex == barOrQrCode.voucherIndex && (
                            <div align="center" style={{ borderTop: "1px solid #f2f2f2", marginTop: 10, paddingTop: 10 }}>
                                {barOrQrCode.name == "barcode" && (
                                    <Barcode value={item} />
                                )}
                                {barOrQrCode.name == "qrcode" && (
                                    <QRCode
                                        id={index}
                                        value={item}
                                        size={290}
                                        level={"H"}
                                        includeMargin={true}
                                    />
                                )}
                            </div>
                        )
                    }
                </div>
            );
        });
    }

    render() {
        const { voucher, currentPage, rowsPerPage, wording } = this.props;
        
        if (voucher.length === 0) {
            return (
                <div className='col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                    <div className=' text-center'>
                        <div className='icon-warpper'>
                            <img src='/assets/img/sf/not-found.png' alt='not-found.png' />
                        </div>
                        <h1 className='uppercase'>{wording.usermenu.voucher.empty}</h1>
                    </div>
                </div>
            );
        }

        return voucher
            .slice((currentPage - 1) * rowsPerPage, (currentPage - 1) * rowsPerPage + rowsPerPage)
            .map((item, index) => {
                return (
                    <div
                        key={item.id}
                        className='content-warpper col-md-12 col-xs-12 product product-grid pt-10 pb-10 ml-10 mr-10'>
                        <div>
                            <p className='mr-10 top-detail-user'>
                                <span className='caption white mr-10'>{wording.usermenu.voucher.invoiceNo}</span>
                                <span className='white mr-10'>{item.invoice}</span>
                                <span className='caption white mr-10'>{wording.usermenu.voucher.voucherOrderDate}</span>
                                <span className='white mr-10'>{item.date}</span>
                            </p>
                            <p>
                                <span className='caption white mr-10'>{wording.usermenu.voucher.status}</span>
                                <span
                                    className={classNames(
                                        {
                                            'status-failed': item.status === 'FAILED',
                                            'status-received': item.status === 'SUCCESS'
                                        },
                                        'mr-10'
                                    )}>
                                    {wording.usermenu.voucher[item.status.toLowerCase()]}
                                </span>
                            </p>
                        </div>
                        {/* Table list item */}
                        <div className='table-wrap' style={{ backgroundColor: 'black' }}>
                            <table className='shop_table cart table'>
                                <thead>
                                    <tr>
                                        <th className='product-name white' colSpan='2'>
                                            {wording.usermenu.voucher.product}
                                        </th>
                                        <th className='product-price white'>{wording.usermenu.voucher.price}</th>
                                        <th className='product-quantity white'>{wording.usermenu.voucher.quantity}</th>
                                        <th className='product-subtotal white'>{wording.usermenu.voucher.total}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {item.item.map(item => {
                                        return (
                                            <tr key={item.itemId} className='cart_item'>
                                                <td className='product-thumbnail'>
                                                    <img
                                                        className='pl-10'
                                                        src={`${API.PRODUCT_IMG_URL}${item.picture}`}
                                                        alt={item.picture}
                                                    />
                                                </td>

                                                <td className='product-name'>
                                                    <a className='white'>{item.name}</a>
                                                </td>

                                                <td className='product-price'>
                                                    <span className='amount white'>
                                                        {`${CURRENCY.B}${formatMoney(parseInt(item.price))}`}
                                                    </span>
                                                </td>

                                                <td className='product-price'>
                                                    <span className='amount white'>{item.amount}</span>
                                                </td>

                                                <td className='product-subtotal'>
                                                    <span className='amount white'>
                                                        {`${CURRENCY.B}${formatMoney(parseInt(item.totalPrice))}`}
                                                    </span>
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>

                        <div className='row'>
                            <div className='col-xs-12 col-md-8'>
                                {item.taxAddress && (
                                    <p className='mt-10'>
                                        <span className='caption white mr-10'>
                                            {wording.usermenu.voucher.taxInvoiceAddress}
                                        </span>
                                        <span className='white'>{`${item.taxAddress.name} ${item.taxAddress.lastName} ${item.taxAddress.taxId}`}</span>
                                        <br />
                                        <span className='white'>{`${item.taxAddress.address != null ? item.taxAddress.address: ''} ${item.taxAddress.district} ${item.taxAddress.province} ${item.taxAddress.zipCode}`}</span>
                                        <br />
                                        <span className='white'>{`${item.taxAddress.phoneNumber} ${item.taxAddress.email}`}</span>
                                    </p>
                                )}
                            </div>
                            <div className='col-xs-12 col-md-4'>
                                <div className='ecommerce-checkout-review-order mr-10' id='order_review'>
                                    <table className='table shop_table ecommerce-checkout-review-order-table'>
                                        <tbody>
                                            <tr className='order-total'>
                                                <th className='white'>
                                                    <strong>{wording.purchase.total}</strong>
                                                </th>
                                                <td>
                                                    <strong>
                                                        <span className='amount white'>
                                                            {`${CURRENCY.B}${formatMoney(parseInt(item.total))}`}
                                                        </span>
                                                    </strong>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        {
                            item.item?.reduce((acc, n) => acc + (n.items?.length || 0), 0) && (
                                <div style={{ borderTop: "1px solid #f2f2f2" }}>
                                    {
                                        item.item?.map((v, i) => (
                                            <Fragment key={i}>
                                                {this.createVoucher(v, index)}
                                            </Fragment>
                                        ))
                                    }
                                </div>
                            )
                        }
                    </div>
                );
            });
    };
}

const mapStateToProps = ({ language }) => ({
    wording: language.wording,
    currentLanguage: language.currentLanguage
});

export default connect(mapStateToProps)(ItemsVoucherOrder);